/**
 * Debug logging utility for development
 */

const isDevelopment = import.meta.env.DEV;

export const debugLog = {
  info: (message: string, data?: any) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log(`🔧 [DEBUG] ${message}`, data || '');
    }
  },
  
  success: (message: string, data?: any) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log(`✅ [DEBUG] ${message}`, data || '');
    }
  },
  
  error: (message: string, error?: any) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.error(`❌ [DEBUG] ${message}`, error || '');
    }
  },
  
  warn: (message: string, data?: any) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.warn(`⚠️  [DEBUG] ${message}`, data || '');
    }
  }
};
